<ta-modal [showCloseIcon]="false">
  <ng-template taModalBody>
    <div class="terms-of-use-content tsc-rich-text" [innerHTML]="data.content | translate" data-test-id="terms-of-use-content"></div>
    <ta-checkbox [checked]="accepted"
                 [label]="(checkLabel$ | async) ?? ''"
                 (onChange)="onAcceptedChange($event)"
                 data-test-id="terms-of-use-accepted"></ta-checkbox>
  </ng-template>
  <ng-template taModalFooter>
    <ta-button size="lg"
               [disabled]="!accepted || saving"
               [loading]="saving"
               (click)="accept()"
               data-test-id="terms-of-use-accept">{{ acceptLabel$ | async }}</ta-button>
  </ng-template>
</ta-modal>
